export enum FilterRequestStatus {
  IN_WORK = 'IN_WORK',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
